
<!--
	作者：Shujuan Sun
	时间：2017-04-10
	描述：监控平台——右侧动态菜单部分
-->
<template>
	<!--车辆监控页面_动态菜单-->
	<div class="btn-group boot-button right_act_ctrl right_baidu_btn" role="group" aria-label="..." >
		
			<div class="popup_filtrate" id="popup_filtrate" v-if="showSrchBox" style="position:absolute;top:44px;right:44px;z-index:19;font-size:12px;">
				<input type="text" class="form-control" id="suggestId" size="20" @focus.once="searchAdds"  />
			</div>
			<div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
		<!--提示-->
			<a v-if="infoWindowMenu" :class="[infoType===0 ?'active':'normal-tool']" @click="noWin">
				<img src="../../../assets/project/images/map/text_icon_61.png" width="44" height="44" alt="无"/>
			</a>
			<a v-if="infoWindowMenu" :class="[infoType===1 ?'active':'normal-tool']" @click="simpleWin">
				<img src="../../../assets/project/images/map/text_icon_62.png" width="44" height="44" alt="简洁"/>
			</a>	
			<a v-if="infoWindowMenu" :class="[infoType===2 ?'active':'normal-tool']" @click="standardWin">
				<img src="../../../assets/project/images/map/text_icon_64.png" width="44" height="44" alt="标准"/>
			</a>
		<!--测量-->
			<a v-if="enableMesaureTool" :class="[measureType===5 ?'active':'normal-tool']" @click="clearMeasure">
				<img src="../../../assets/project/images/map/text_icon_51.png" width="44" height="44" alt="清空"/>
			</a>
			<a v-if="enableMesaureTool" :class="[measureType===0 ?'active':'normal-tool']" @click="meRoad(0)">
				<img src="../../../assets/project/images/map/text_icon_52.png" width="44" height="44" alt="测路线"/>
			</a>
			<a v-if="enableMesaureTool" :class="[measureType===1 ?'active':'normal-tool']" @click="meBeeline(1)">
				<img src="../../../assets/project/images/map/text_icon_53.png" width="44" height="44" alt="测直线"/>
			</a>
			<a v-if="enableMesaureTool" :class="[measureType===2 ?'active':'normal-tool']" @click="meArea(2)">
				<img src="../../../assets/project/images/map/text_icon_54.png" width="44" height="44" alt="测面积"/>
			</a>
			<a v-if="enableMesaureTool" :class="[measureType===3 ?'active':'normal-tool']" @click="coordinate(3)">
				<img src="../../../assets/project/images/map/text_icon_55.png" width="44" height="44" alt="取坐标"/>
			</a>
			<a v-if="enableMesaureTool" :class="[measureType===4 ?'active':'normal-tool']" @click="searchAddress(4)">
					<img src="../../../assets/project/images/map/text_icon_56.png" width="44" height="44" alt="查地址"/>
			</a> 
		<button v-if="showBtn" style="outline:none;" type="button" class="menu_btn right_act_btn" id="tool" @click="toggleMenu" :class="[rollUp?'downArrow':'upArrow']" data-toggle="tooltip" data-placement="bottom" title="折叠"></button>
	</div>
	<!--车辆监控页面_动态菜单结束-->
</template>
<script>
	import {mapState} from 'vuex' 
	export default {
		name: 'MenuMapTool',
		data() {
			return {
				rollUp:false
			}
		},
		props:['enableDrawingTool','currentMenu','infoWindowMenu','enableMesaureTool','measureType','infoType'],
		computed:{
			showBtn:function(){
				return this.enableMesaureTool || this.currentMenu == 2 ||  this.infoWindowMenu  || this.measureType
			},
			showSrchBox:function(){
				return this.measureType === 4 
			}
		},
		mounted(){
			$(function () {//启用tooltip
			  $('[data-toggle="menutooltip"]').tooltip()
			})
		},
		updated(){
			this.$nextTick(function(){
				$('[data-toggle="menutooltip"]').tooltip()
				$('[data-toggle="menutooltip"]').hover(function(){
					$(this).attr('title',$(this).attr('title')).tooltip('fixTitle').tooltip('show')
				})
			})
		},
		destroyed(){
			$('[data-toggle="menutooltip"]').tooltip('hide')
		},
		methods: {
			toggleMenu(){
				this.rollUp = !this.rollUp
				$(".right_baidu_btn .normal-tool").toggle(300);
				$(".right_baidu_btn .active").toggle(300);
				$('#popup_filtrate').toggle(300);
			},
			noWin(){
				this.$emit('noWin')
			},
			simpleWin(){
				this.$emit('simpleWin')
			},
			standardWin(){
				this.$emit('standardWin')
			},
			meRoad(){
				this.$emit('meRoad')
			},
			meBeeline(){
				this.$emit('meBeeline')
			},
			meArea(){
				this.$emit('meArea')
			},
			coordinate(){
				this.$emit('coordinate')
			},
			searchAddress(){
				this.$emit('searchAddress')
			},
			clearMeasure(){
				this.$emit('clearMeasure')
			},
			searchAdds(){
				this.$emit('searchAdds')
			}
		}
	}
</script>


// WEBPACK FOOTER //
// MenuMapTool.vue?fcbc3166